// Env.tsx
import React, {useState, useEffect} from 'react';

const Env: React.FC = () => {
    const [env, setEnv] = useState<string | null>(null);

    useEffect(() => {
    }, []);

    return (
        <div className="Env">
            <h1>Env</h1>
            <p>Env content goes here.</p>
        </div>
    );
};

export default Env;